import { Component, OnInit , Input ,ChangeDetectorRef } from '@angular/core';
import {NgbModal, NgbModalOptions, NgbActiveModal,  ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-alertdialog',
  templateUrl: './alertdialog.component.html',
  styleUrls: ['./alertdialog.component.css']
})
export class AlertdialogComponent implements OnInit {
	@Input() message;
  constructor(public activeModal: NgbActiveModal, public changeRef: ChangeDetectorRef) { }

  ngOnInit() {
  }

  dismiss(){
  	this.activeModal.close(false)
  }

  close(flag){
  	this.activeModal.close(flag)
  }


}



// WEBPACK FOOTER //
// ./src/app/alertdialog/alertdialog.component.ts